module.exports = __webpack_public_path__ + "img/24d732c3c14e55f6b21f4720a73871cd.svg";